<template>
  <div class="md:container px-4 md:mb-16 mb-10">
    <section id="feature">
      <div class="text-center md:mb-14 mb-10">
        <p class="tracking-widest uppercase text-primary font-rubik-medium">
          {{ $t('moreFeature.title') }}
        </p>
        <h3 class="font-bree-serif md:text-3xl mt-6">
          {{ $t('moreFeature.subtitle') }}
        </h3>
      </div>
      <div class="grid lg:grid-cols-4 sm:grid-cols-2 gap-5">
        <template v-for="(feature, index) in features">
          <div :key="index">
            <card-with-number rounded="12" bg-color="#F1F3FE" min-height="200px">
              <div class="flex flex-col justify-center items-center text-center" style="min-height: 200px">
                <img v-lazy-load :data-src="feature.image" alt="" class="mx-auto">
                <p class="font-rubik-medium text-lg my-4">
                  {{ $t(feature.title) }}
                </p>
              </div>
            </card-with-number>
          </div>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Feature',
  data: () => ({
    features: [
      {
        title: 'features.inviteDoctor',
        image: require('@/assets/icon/icon-add-doctor.svg')
      },
      {
        title: 'features.taggingDoctor',
        image: require('@/assets/icon/icon-tag-doctor.svg')
      },
      {
        title: 'features.statisticAndAnalytic',
        image: require('@/assets/icon/icon-track-activity.svg')
      },
      {
        title: 'features.consultationPlayback',
        image: require('@/assets/icon/icon-recording.svg')
      },
      {
        title: 'features.withdrawFunds',
        image: require('@/assets/icon/icon-withdraw.svg')
      },
      {
        title: 'features.adminAccount',
        image: require('@/assets/icon/icon-admin-account.svg')
      },
      {
        title: 'features.flexibleSchedules',
        image: require('@/assets/icon/icon-flexible-doctor-schedule.svg')
      },
      {
        title: 'features.marketingMedia',
        image: require('@/assets/icon/icon-promotion.svg')
      }
    ]
  })
}
</script>

<style scoped>

</style>
